module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex content-config-cluster",
    attrs: {
      "id": "content-config-cluster"
    }
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('FrameOpenClose', {
    attrs: {
      "title": "Clusters"
    }
  }, [_vm._l((_vm.getClusters), function(cluster) {
    return _c('div', [_vm._v(_vm._s(cluster.name))])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [(_vm.clusterSelected != null) ? _c('TemplatePlano', {
    attrs: {
      "data": _vm.clusterSelected
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('Elements', {
    attrs: {
      "cluster": 1
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0759ae80","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plano/config/Cluster.vue
// module id = 2993
// module chunks = 0